import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {KeyUtilsPL2 as KU} from '@common/utils/dist/utils/key-utils-pl2.js';
import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';
import {EntryState} from '@stores/entry.store';
import {EntryStoreUtils as ESU} from '@utils/entry-store-utils';

export namespace ScopeUtils {
  export function getMaxLGI(aPK: string, entryState: EntryState): number {
    const sCLGIs = Object.keys(entryState)
      .filter(
        (cPK) =>
          cPK.startsWith(aPK) &&
          KU.isType(PL2.EntryType.StudentCopy, cPK) &&
          ESU.isActive(entryState, cPK),
      )
      .map((cPK) => (entryState[cPK]?.e as PL2.LabReportUserEntry)?.lGI)
      .filter((lGI) => !U.isEmpty(lGI));

    const cPK = KU.parentPK(aPK);
    const sULGIs = (entryState[cPK]?.c ?? [])
      .filter((pK) => KU.isType(PL2.EntryType.StudentUser, pK))
      .map((pK) => (entryState[pK]?.e as PL2.StudentUserEntry).lGI)
      .filter((lGI) => !U.isEmpty(lGI));
    return Math.max(...sCLGIs, ...sULGIs);
  }
}
